import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const RewardsParameters = ({ onNext = () => {}, onBack = () => {}, inputs, canGoNext }) => {
  const { t } = useTranslation(['rewards-loyalty', 'common'])
  return (
    <div>
      <div className="rewards-modal-content rewards-base-view loyalty-parameters">
        <div className="rewards-modal-input-row" style={{ display: 'flex', gap: 8 }}>
          {inputs.first && (
            <div className="input-container" style={{ width: '50%' }}>
              <div className={`input-label ${inputs.first.disabled ? 'disabled' : ''}`}>
                {inputs.first.label}
              </div>
              {inputs.first.render()}
            </div>
          )}
          {inputs.second && (
            <div className="input-container" style={{ width: '50%' }}>
              <div className={`input-label ${inputs.second.disabled ? 'disabled' : ''}`}>
                {inputs.second.label}
              </div>
              {inputs.second.render()}
            </div>
          )}
        </div>
        <div className="rewards-modal-input-row">
          {inputs.third && (
            <div className="input-container">
              <div className={`input-label ${inputs.third.disabled ? 'disabled' : ''}`}>
                {inputs.third.label}
              </div>
              {inputs.third.render()}
            </div>
          )}
        </div>
        <div className="rewards-modal-input-row">
          {inputs.fourth && (
            <div className="input-container">
              <div className={`input-label ${inputs.fourth.disabled ? 'disabled' : ''}`}>
                {inputs.fourth.label}
              </div>
              {inputs.fourth.render()}
            </div>
          )}
        </div>
        <div className="rewards-modal-input-row">
          {inputs.fifth && inputs.fifth.isVisible && (
            <div className="input-container">
              <div className={`input-label ${inputs.fifth.disabled ? 'disabled' : ''}`}>
                {inputs.fifth.label}
              </div>
              {inputs.fifth.render()}
            </div>
          )}
        </div>
      </div>
      <div className="rewards-modal-actions">
        <button className="button button-gray" onClick={onBack}>
          {t('common:actions.back')}
        </button>
        <button className="button button-primary auto-width" disabled={!canGoNext} onClick={onNext}>
          {t('rewards-loyalty:activityForm.nextButton')}
        </button>
      </div>
    </div>
  )
}

RewardsParameters.propTypes = {
  onNext: PropTypes.func,
  onBack: PropTypes.func,
  inputs: PropTypes.object,
  canGoNext: PropTypes.bool,
}

export default RewardsParameters
